import Collapse from '@mui/material/Collapse'
import Tooltip from '@mui/material/Tooltip'
import { forwardRef, PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import { SIDEBAR_ICON_SIZE, SIDEBAR_ICON_SPACING } from './styles'

import Box from '@mui/material/Box'

interface ExternalLinkProps {
  to: string
  onClick?: ((event: React.MouseEvent<HTMLAnchorElement>) => void)
  className?: string
}

type ExternalLink = React.FC<PropsWithChildren<ExternalLinkProps>>

interface SidebarlinkProps {
  iconSrc?: React.ElementType | string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  showLabel: boolean
  tooltipText: string
  to: string
}

const ExternalLink = forwardRef<HTMLAnchorElement, PropsWithChildren<ExternalLinkProps>>(({to, children, onClick, className}, ref) => {
  return (
    <a ref={ref} className={className} href={to} onClick={onClick} target="_blank" rel="noreferrer" role="tab">
      {children}
    </a>
  )
})
ExternalLink.displayName = 'ExternalLink'

const SidebarLink = forwardRef<HTMLAnchorElement, PropsWithChildren<SidebarlinkProps>>(({children, iconSrc: Icon, onClick, showLabel, tooltipText, to, ...props}, ref) => {
  const LinkComponent : typeof Link | ExternalLink = to?.match(/^(?:https?:)?\/\//) ? ExternalLink : Link

  return (
    <LinkComponent {...props} to={to || '#'} ref={ref} onClick={onClick}>
      <Tooltip title={tooltipText} disableHoverListener={showLabel}>
        <Box sx={{
          width: `${SIDEBAR_ICON_SIZE}px`,
          height: `${SIDEBAR_ICON_SIZE}px`,
          marginRight: `${SIDEBAR_ICON_SPACING}px`,
          display: 'flex',
          alignItems: 'center',
        }}>
        {
          ((typeof(Icon) === 'object') || (typeof(Icon) === 'function')) && (
            <Icon sx={{ margin: '0 auto', display: 'block' }} />
          ) || (typeof(Icon) === 'string') && (
            <Box component="img" sx={{ margin: '0 auto', display: 'block' }} src={Icon}/>
          )
        }
        </Box>
      </Tooltip>

      <Collapse orientation="horizontal" in={showLabel}>
        {children}
      </Collapse>
    </LinkComponent>
  )
})
SidebarLink.displayName = 'SidebarLink'

export default SidebarLink
